export const toDeviceIdArray = (value: number | number[] | null): number[] => {
	if (value == null) return []
	return Array.isArray(value) ? value : [value]
}
